import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import playerData from "./updated_players_with_sbmvp.json";
import playerSchedule from "./playerSchedule.json"; // Import the schedule
import PageInfo from "../PageInfo/PageInfo";
import {
  Checkbox,
  Container,
  Dialog,
  FormControlLabel,
  TextField,
  FormControl,
  RadioGroup,
  Radio,
  Modal,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  IconButton,
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import sports from "../../sports";
import crossover_logo from "../../assets/nfl.svg";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterListIcon from "@mui/icons-material/FilterList";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment-timezone";

const GuessThePlayer = () => {
  // Seeded random number generator for deterministic daily player selection
  const getDailyPlayerIndex = (dateString, arrayLength) => {
    // Simple hash function to convert date string to a number
    let hash = 0;
    for (let i = 0; i < dateString.length; i++) {
      const char = dateString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    // Use absolute value and modulo to get index within array bounds
    return Math.abs(hash) % arrayLength;
  };

  // MUI Button Styles
  const primaryButtonSx = {
    background: 'linear-gradient(135deg, #4666af 0%, #27408b 100%)',
    color: 'white',
    border: 'none',
    padding: '14px 28px',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    boxShadow: '0 4px 12px rgba(70, 102, 175, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #27408b 0%, #1a2d5f 100%)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(70, 102, 175, 0.4)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  };

  const secondaryButtonSx = {
    background: 'rgba(70, 102, 175, 0.1)',
    color: '#4666af',
    border: '2px solid rgba(70, 102, 175, 0.3)',
    padding: '10px 20px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    boxShadow: '0 2px 8px rgba(70, 102, 175, 0.15)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(70, 102, 175, 0.15)',
      borderColor: 'rgba(70, 102, 175, 0.5)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(70, 102, 175, 0.2)',
    },
  };

  // Container and Card styles
  const containerSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '32px 20px',
    minHeight: '100vh',
  };

  const cardSx = {
    backgroundColor: 'background.paper',
    padding: '32px',
    borderRadius: '20px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.1)',
    border: '1px solid',
    borderColor: 'divider',
    width: '100%',
    maxWidth: '800px',
    margin: '20px auto',
  };

  const sectionSx = {
    marginBottom: '24px',
  };

  const infoBlockSx = {
    padding: '16px',
    marginBottom: '16px',
    backgroundColor: 'rgba(70, 102, 175, 0.05)',
    borderRadius: '12px',
    border: '1px solid rgba(70, 102, 175, 0.2)',
  };

  const [mode, setMode] = useState("CFBHome"); // Mode can be 'CFBHome' or 'Unlimited'
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [guessesLeft, setGuessesLeft] = useState(3);
  const [userGuess, setUserGuess] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [currentDate, setCurrentDate] = useState(
    moment().tz("America/New_York").format("YYYY-MM-DD")
  );
  const [playedToday, setPlayedToday] = useState(
    localStorage.getItem(currentDate) === "played"
  );
  const [hintsGiven, setHintsGiven] = useState([]);
  const [page_name, setPageName] = useState(""); // Define page_name state
  const [sport_id, setSportId] = useState(""); // Define sport_id state
  const currentSport = sports.find((sport) => sport.id === sport_id.toString());
  const [selectedTeams, setSelectedTeams] = useState(new Set());
  const [currentPlayerId, setCurrentPlayerId] = useState(null);
  const hasDraftDetails =
    currentPlayer &&
    (currentPlayer.Round || currentPlayer.Pick || currentPlayer.DrftYr);
  // Additional state within the GuessThePlayer component
  const [leaderboard, setLeaderboard] = useState([]);
  const [showLeaderboardModal, setShowLeaderboardModal] = useState(false);
  const [showNoPlayersModal, setShowNoPlayersModal] = useState(false);

  const [playerIDInput, setPlayerIDInput] = useState(
    localStorage.getItem("playerID") || ""
  );
  const [seenPlayerIDs, setSeenPlayerIDs] = useState(new Set());
  const [outOfPlayers, setOutOfPlayers] = useState(false);
  const [showEditPlayerIDModal, setShowEditPlayerIDModal] = useState(false);
  const [showStreakModal, setShowStreakModal] = useState(false);
  const [selectedAwards, setSelectedAwards] = useState(new Set());
  const [tempSelectedAwards, setTempSelectedAwards] = useState(
    new Set(selectedAwards)
  );
  const awards = [
    "Pro_Bowl",
    "MVP",
    "AP1",
    "SB_MVP",
    "OPOY",
    "DPOY",
    "CPOY",
    "OROY",
    "DROY",
  ]; // Add all relevant awards

  const toggleEditPlayerIDModal = () => {
    setShowEditPlayerIDModal((prev) => !prev);
  };
  const EditPlayerIDModal = ({ open, onClose }) => {
    const [tempPlayerID, setTempPlayerID] = useState(playerIDInput);

    const handleSave = () => {
      savePlayerID(tempPlayerID);
      onClose(); // Close modal after save
    };

    useEffect(() => {
      if (open) {
        setTempPlayerID(playerIDInput); // Reset local state when modal opens
      }
    }, [open]);

    return (
      <Dialog open={open} onClose={onClose}>
        <div style={{ padding: 20 }}>
          <h2>Edit Player ID</h2>
          <TextField
            fullWidth
            label="Player ID"
            value={tempPlayerID}
            onChange={(e) => setTempPlayerID(e.target.value)}
            margin="normal"
          />
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
        </div>
      </Dialog>
    );
  };

  const [selectedPositions, setSelectedPositions] = useState(new Set());
  const [isActiveOnly, setIsActiveOnly] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [tempSelectedPositions, setTempSelectedPositions] = useState(new Set());
  const [tempSelectedTeams, setTempSelectedTeams] = useState(new Set());
  const [draftStatus, setDraftStatus] = useState("both"); // drafted, undrafted, both
  const [minGames, setMinGames] = useState(0); // Minimum number of games played
  const [tempDraftStatus, setTempDraftStatus] = useState("both");
  const [tempMinGames, setTempMinGames] = useState(0);

  const [tempIsActiveOnly, setTempIsActiveOnly] = useState(false);
  // Track different statistics for each game mode
  const [homeTotalGames, setHomeTotalGames] = useState(
    parseInt(localStorage.getItem("homeTotalGames") || 0)
  );
  const [homeTotalWins, setHomeTotalWins] = useState(
    parseInt(localStorage.getItem("homeTotalWins") || 0)
  );
  const [homeWinStreak, setHomeWinStreak] = useState(
    parseInt(localStorage.getItem("homeWinStreak") || 0)
  );
  const [unlimitedTotalGames, setUnlimitedTotalGames] = useState(
    parseInt(localStorage.getItem("unlimitedTotalGames") || 0)
  );
  const [unlimitedTotalWins, setUnlimitedTotalWins] = useState(
    parseInt(localStorage.getItem("unlimitedTotalWins") || 0)
  );
  const [unlimitedWinStreak, setUnlimitedWinStreak] = useState(
    parseInt(localStorage.getItem("unlimitedWinStreak") || 0)
  );
  const [homeHighestStreak, setHomeHighestStreak] = useState(
    parseInt(localStorage.getItem("homeHighestStreak") || 0)
  );
  const [unlimitedHighestStreak, setUnlimitedHighestStreak] = useState(
    parseInt(localStorage.getItem("unlimitedHighestStreak") || 0)
  );
  const [isDarkMode, setIsDarkMode] = useState(false);
  const teams = [
    "ARI",
    "ATL",
    "BAL",
    "BUF",
    "CAR",
    "CHI",
    "CIN",
    "CLE",
    "DAL",
    "DEN",
    "DET",
    "GNB",
    "HOU",
    "IND",
    "JAX",
    "KAN",
    "LAR",
    "LAC",
    "LVR",
    "MIA",
    "MIN",
    "NOR",
    "NWE",
    "NYG",
    "NYJ",
    "PHI",
    "PIT",
    "SFO",
    "SEA",
    "TAM",
    "TEN",
    "WAS",
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0); // Assume you handle setting this based on the response
  const [lastVisibleId, setLastVisibleId] = useState(null); // to manage cursor for pagination
  const [hasNextPage, setHasNextPage] = useState(true);

  useEffect(() => {
    const filters = {
      teams: [...selectedTeams],
      positions: [...selectedPositions],
      isActiveOnly,
      draftStatus,
      minGames,
      awards: [...selectedAwards], // Include selected awards in stored filters
    };
    localStorage.setItem("filters", JSON.stringify(filters));
  }, [
    selectedTeams,
    selectedPositions,
    isActiveOnly,
    draftStatus,
    minGames,
    selectedAwards,
  ]); // Add selectedAwards as a dependency

  useEffect(() => {
    const loadedFilters = JSON.parse(localStorage.getItem("filters")) || {};
    setSelectedTeams(new Set(loadedFilters.teams || []));
    setSelectedPositions(new Set(loadedFilters.positions || []));
    setIsActiveOnly(loadedFilters.isActiveOnly || "both");
    setDraftStatus(loadedFilters.draftStatus || "both");
    setMinGames(loadedFilters.minGames || 0);
    setSelectedAwards(new Set(loadedFilters.awards || [])); // Load selected awards from stored filters
  }, []); // No dependencies to trigger this effect initially

  const fetchLeaderboard = async (next = false) => {
    let nextPage = next ? currentPage + 1 : 1; // Increment or reset to first page
    let url = `https://us-central1-crossover-grid-511a4.cloudfunctions.net/api/getLeaderboard?page=${nextPage}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        if (next && data.leaderboard.length > 0) {
          setLeaderboard((prevLeaderboard) => [
            ...prevLeaderboard,
            ...data.leaderboard,
          ]);
          setCurrentPage(nextPage);
        } else if (!next) {
          setLeaderboard(data.leaderboard);
          setCurrentPage(1);
        }
        setHasNextPage(data.hasNextPage); // Update hasNextPage state based on the API response
      } else {
        toast.error(`Error: ${data.message || "Failed to fetch leaderboard"}`);
        setLeaderboard([]);
        setHasNextPage(false); // Assume no more pages if an error occurs
      }
    } catch (error) {
      toast.error(`Network error: ${error.toString()}`);
      setHasNextPage(false); // Assume no more pages if a network error occurs
    }
  };

  const [showHowToPlay, setShowHowToPlay] = useState(false);

  const toggleHowToPlayModal = () => {
    setShowHowToPlay((prev) => !prev);
  };

  const HowToPlayModal = ({ open, onClose }) => (
    <Dialog open={open} onClose={onClose}>
      <div style={{ padding: 20 }}>
        <h2>📚 How to Play</h2>
        <p>Ready to test your player knowledge? Here's what you need to do:</p>
        <ul>
          <li>
            <strong>🚀 Pick a mode:</strong> Choose between 'CFBHome' or
            'Unlimited' to start playing.
          </li>
          <li>
            <strong>🛠 Set your filters:</strong> Fine-tune the list of players
            by selecting specific teams, positions, or statuses to make your
            players more manageable.
          </li>
          <li>
            <strong>🔍 Make your guess:</strong> Type the name of who you think
            it is into the input field and see if you're right.
          </li>
          <li>
            <strong>💡 Use hints:</strong> If your first guess isn’t quite
            right, we’ll give you some hints like position and draft round to
            help steer you in the right direction.
          </li>
          <li>
            <strong>🏆 Keep your streak alive:</strong> Guess as many as you can
            in a row. Also, don’t forget to save your username to compete on the
            leaderboard where your highest streak will appear!
          </li>
        </ul>
        <Button onClick={onClose} color="primary">
          Got it, let's play!
        </Button>
      </div>
    </Dialog>
  );

  const openLeaderboardModal = () => {
    fetchLeaderboard(); // Fetch with the initial page
    setShowLeaderboardModal(true);
  };

  const handleNextPage = () => {
    fetchLeaderboard(true); // Fetch next page
  };

  const closeLeaderboardModal = () => {
    setShowLeaderboardModal(false);
  };

  const handlePreviousPage = () => {
    const prevPage = currentPage - 1;
    if (prevPage > 0) {
      setCurrentPage(prevPage);
      fetchLeaderboard(prevPage);
    }
  };

  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };
  const resetFiltersToDefault = () => {
    setSelectedTeams(new Set());
    setSelectedPositions(new Set());
    setIsActiveOnly("both");
    setDraftStatus("both");
    setMinGames(0);
    // Save these defaults back to localStorage
    localStorage.setItem(
      "filters",
      JSON.stringify({
        teams: [],
        positions: [],
        isActiveOnly: "both",
        draftStatus: "both",
        minGames: 0,
      })
    );
  };

  const savePlayerID = (newPlayerID) => {
    if (
      leaderboard.some(
        (item) => item.playerID.toString() === newPlayerID.toString()
      ) ||
      newPlayerID.trim() !== ""
    ) {
      setPlayerIDInput(newPlayerID); // Update the global state
      localStorage.setItem("playerID", newPlayerID);
      alert("Player ID saved!");
    } else {
      alert("Player ID does not exist in the leaderboard!");
    }
  };

  const LeaderboardModal = ({
    open,
    onClose,
    leaderboard,
    fetchMoreLeaderboard,
  }) => {
    const [isLoading, setIsLoading] = useState(false);
    const loaderRef = useRef(null);
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          // Ensure that the isIntersecting property is checked properly
          if (entries[0].isIntersecting && !isLoading) {
            // Also check isLoading to avoid duplicate calls
            setIsLoading(true); // Set loading state to true
            fetchLeaderboard(true).then(() => setIsLoading(false)); // Set loading state to false after fetching
          }
        },
        { threshold: 1.0 }
      );

      if (loaderRef.current) {
        observer.observe(loaderRef.current);
      }

      return () => observer.disconnect();
    }, [loaderRef.current, isLoading]); // Include isLoading in the dependency array

    return (
      <Modal
        open={open}
        onClose={() => {
          onClose();
          setIsLoading(false); // Reset loading state on close
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '80%' },
          maxWidth: '600px',
          backgroundColor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          padding: '32px',
          maxHeight: '90vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Typography variant="h5" component="h2" sx={{ marginBottom: '24px', fontWeight: 700, textAlign: 'center' }}>
            Leaderboard
          </Typography>
          <Box sx={{ flexGrow: 1, overflow: 'auto', marginBottom: '16px' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Player</TableCell>
                  <TableCell align="right">Longest Streak</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {leaderboard.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.playerID}</TableCell>
                    <TableCell align="right">{row.score}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {isLoading && (
              <Box sx={{ textAlign: 'center', padding: '20px' }}>
                <CircularProgress />
              </Box>
            )}
            {hasNextPage && (
              <Button
                onClick={() => fetchLeaderboard(true)}
                variant="contained"
                color="primary"
                disabled={isLoading}
                fullWidth
              >
                Load More Scores
              </Button>
            )}
          </Box>
          <Button onClick={onClose} variant="outlined" sx={{ ...secondaryButtonSx, marginTop: '16px' }} fullWidth>
            Close
          </Button>
        </Box>
      </Modal>
    );
  };

  const teamLogos = {
    ARI: "https://loodibee.com/wp-content/uploads/nfl-arizona-cardinals-team-logo-2-768x768.png",
    ATL: "https://loodibee.com/wp-content/uploads/nfl-atlanta-falcons-team-logo-2-768x768.png",
    BAL: "https://loodibee.com/wp-content/uploads/nfl-baltimore-ravens-team-logo-2-768x768.png",
    BUF: "https://loodibee.com/wp-content/uploads/nfl-buffalo-bills-team-logo-2-768x768.png",
    CAR: "https://loodibee.com/wp-content/uploads/nfl-carolina-panthers-team-logo-2-768x768.png",
    CHI: "https://loodibee.com/wp-content/uploads/nfl-chicago-bears-team-logo-2-768x768.png",
    CIN: "https://loodibee.com/wp-content/uploads/nfl-cincinnati-bengals-team-logo-2-768x768.png",
    CLE: "https://loodibee.com/wp-content/uploads/nfl-cleveland-browns-team-logo-2-768x768.png",
    DAL: "https://loodibee.com/wp-content/uploads/nfl-dallas-cowboys-team-logo-2-768x768.png",
    DEN: "https://loodibee.com/wp-content/uploads/nfl-denver-broncos-team-logo-2-768x768.png",
    DET: "https://loodibee.com/wp-content/uploads/nfl-detroit-lions-team-logo-2-768x768.png",
    GNB: "https://loodibee.com/wp-content/uploads/nfl-green-bay-packers-team-logo-2-768x768.png",
    HOU: "https://loodibee.com/wp-content/uploads/nfl-houston-texans-team-logo-2-768x768.png",
    IND: "https://loodibee.com/wp-content/uploads/nfl-indianapolis-colts-team-logo-2-768x768.png",
    JAX: "https://loodibee.com/wp-content/uploads/nfl-jacksonville-jaguars-team-logo-2-768x768.png",
    KAN: "https://loodibee.com/wp-content/uploads/nfl-kansas-city-chiefs-team-logo-2-768x768.png",
    LAR: "https://loodibee.com/wp-content/uploads/los-angeles-rams-2020-logo.png",
    LAC: "https://loodibee.com/wp-content/uploads/nfl-los-angeles-chargers-team-logo.png",

    LVR: "https://loodibee.com/wp-content/uploads/nfl-oakland-raiders-team-logo.png",
    MIA: "https://loodibee.com/wp-content/uploads/nfl-miami-dolphins-team-logo-2-768x768.png",
    MIN: "https://loodibee.com/wp-content/uploads/nfl-minnesota-vikings-team-logo-2-768x768.png",
    NOR: "https://loodibee.com/wp-content/uploads/nfl-new-orleans-saints-team-logo-2-768x768.png",
    NWE: "https://loodibee.com/wp-content/uploads/nfl-new-england-patriots-team-logo-2-768x768.png",
    NYG: "https://loodibee.com/wp-content/uploads/nfl-new-york-giants-team-logo-2-768x768.png",
    NYJ: "https://loodibee.com/wp-content/uploads/nfl-new-york-jets-team-logo.png",
    PHI: "https://loodibee.com/wp-content/uploads/nfl-philadelphia-eagles-team-logo-2-768x768.png",
    PIT: "https://loodibee.com/wp-content/uploads/nfl-pittsburgh-steelers-team-logo-2-768x768.png",
    SFO: "https://loodibee.com/wp-content/uploads/nfl-san-francisco-49ers-team-logo-2-768x768.png",
    SEA: "https://loodibee.com/wp-content/uploads/nfl-seattle-seahawks-team-logo-2-768x768.png",
    TAM: "https://loodibee.com/wp-content/uploads/nfl-tampa-bay-buccaneers-team-logo-2-768x768.png",
    TEN: "https://loodibee.com/wp-content/uploads/nfl-tennessee-titans-team-logo-2-768x768.png",
    WAS: "https://loodibee.com/wp-content/uploads/washington-commanders-logo.png",
  };

  const toggleTeam = (team) => {
    // This assumes there is no distinction between temporary and final state,
    // which might not always be appropriate for settings dialogs.
    setTempSelectedTeams((prevTeams) => {
      const newTeams = new Set(prevTeams);
      if (newTeams.has(team)) {
        newTeams.delete(team);
      } else {
        newTeams.add(team);
      }
      return newTeams;
    });

    setSelectedTeams((prev) => {
      const updatedTeams = new Set(prev);
      if (updatedTeams.has(team)) {
        updatedTeams.delete(team);
      } else {
        updatedTeams.add(team);
      }
      return updatedTeams;
    });
  };

  useEffect(() => {
    // Check if the user prefers dark mode
    const prefersDarkMode =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    setIsDarkMode(prefersDarkMode);

    // Listen for changes in the dark mode preference
    const mediaQueryListener = (e) => {
      setIsDarkMode(e.matches);
    };

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addListener(mediaQueryListener);

    return () => {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeListener(mediaQueryListener);
    };
  }, []);
  useEffect(() => {
    // Apply or remove the dark-mode class based on the isDarkMode state
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDarkMode]);

  const onAdRefresh = () => {
    window.freestar?.queue.push(function () {
      window.freestar?.newStickyFooter("crossovergrid_sticky_footer");
      window.freestar?.refresh("crossovergrid_sidewall_left");
      window.freestar?.refresh("crossovergrid_sidewall_right");
    });
  };

  // Function to handle year range change and automatically close menu
  useEffect(() => {
    onAdRefresh();
  }, []);

  useEffect(() => {
    // This effect should only run for changes in currentDate and mode, specifically when in CFBHome mode.
    if (mode === "CFBHome") {
      // First check if there's a manually scheduled player for this date
      const playerId = playerSchedule[currentDate];
      if (playerId) {
        const scheduledPlayer = playerData.find(
          (p) => p["Player-additional"] === playerId
        );
        if (scheduledPlayer) {
          setCurrentPlayer(scheduledPlayer);
          return;
        }
      }

      // Otherwise, use deterministic daily selection based on date
      const dailyIndex = getDailyPlayerIndex(currentDate, playerData.length);
      setCurrentPlayer(playerData[dailyIndex]);
      console.log(`Daily player for ${currentDate}: ${playerData[dailyIndex]?.Player} (index ${dailyIndex})`);
    }
  }, [currentDate, mode]);

  useEffect(() => {
    // This will refresh the currentDate at 7:00 AM EST every day
    const now = moment().tz("America/New_York");
    const tomorrow = now.clone().add(1, "days").startOf("day");
    const msUntil7AM = tomorrow.add(7, "hours").diff(now);

    const timer = setTimeout(() => {
      setCurrentDate(moment().tz("America/New_York").format("YYYY-MM-DD"));
      setPlayedToday(localStorage.getItem(currentDate) === "played");
    }, msUntil7AM);

    return () => clearTimeout(timer);
  }, [currentDate]);

  useEffect(() => {
    // Fetch player data on mount or when mode or date changes
    if (mode === "CFBHome") {
      const playerId = playerSchedule[currentDate];
      const scheduledPlayer = playerData.find(
        (p) => p["Player-additional"] === playerId
      );

      if (scheduledPlayer) {
        setCurrentPlayer(scheduledPlayer);
      } else {
        // Use deterministic daily selection
        const dailyIndex = getDailyPlayerIndex(currentDate, playerData.length);
        setCurrentPlayer(playerData[dailyIndex]);
      }
    }
    setPlayedToday(localStorage.getItem(currentDate) === "played");
  }, [mode, currentDate]);
  useEffect(() => {
    localStorage.setItem("homeHighestStreak", homeHighestStreak.toString());
    localStorage.setItem(
      "unlimitedHighestStreak",
      unlimitedHighestStreak.toString()
    );
  }, [homeHighestStreak, unlimitedHighestStreak]);

  const handleModeChange = () => {
    const newMode = mode === "CFBHome" ? "Unlimited" : "CFBHome";
    setMode(newMode);
    resetGameState();
  };

  const resetGameState = () => {
    setGuessesLeft(3);
    setUserGuess("");
    setSuggestions([]);
    setHintsGiven([]);
    setSeenPlayerIDs(new Set()); // Optionally reset seen IDs on mode change
    fetchPlayer(mode); // Ensure this fetches according to the new mode
  };

  const generatePlayerID = () => {
    return "id-" + Math.random().toString(36).substr(2, 9); // This creates a random alphanumeric string prefixed with 'id-'
  };

  const updateWinsAndStreak = () => {
    const updateWins =
      mode === "CFBHome" ? setHomeTotalWins : setUnlimitedTotalWins;
    const updateStreak =
      mode === "CFBHome" ? setHomeWinStreak : setUnlimitedWinStreak;
    const updateHighestStreak =
      mode === "CFBHome" ? setHomeHighestStreak : setUnlimitedHighestStreak;

    updateWins((wins) => wins + 1);
    updateStreak((streak) => {
      const newStreak = streak + 1;
      if (
        newStreak >
        (mode === "CFBHome" ? homeHighestStreak : unlimitedHighestStreak)
      ) {
        updateHighestStreak(newStreak);
        localStorage.setItem(
          mode === "CFBHome" ? "homeHighestStreak" : "unlimitedHighestStreak",
          newStreak.toString()
        );
      }
      return newStreak;
    });
  };

  const resetStreak = async () => {
    const currentStreak =
      mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;

    // Retrieve player ID from storage or generate a new one if not found
    let playerID = localStorage.getItem("playerID");
    if (!playerID) {
      playerID = generatePlayerID();
      localStorage.setItem("playerID", playerID); // Optionally store the newly generated ID back to local storage
    }

    // Post streak to leaderboard if a streak exists
    if (currentStreak > 0) {
      await postStreakToLeaderboard(playerID, currentStreak).catch((error) => {
        toast.error("Error updating leaderboard: " + error.message);
      });
    }

    // Reset the streak
    const reset = mode === "CFBHome" ? setHomeWinStreak : setUnlimitedWinStreak;
    reset(0); // Reset the streak
  };
  useEffect(() => {
    const storedMode = localStorage.getItem("gameMode");
    // Only use stored mode if it's valid
    if (storedMode === "CFBHome" || storedMode === "Unlimited") {
      setMode(storedMode);
    } else {
      // Clear invalid stored mode
      localStorage.removeItem("gameMode");
      setMode("CFBHome"); // Default to CFBHome
    }
  }, []);

  useEffect(() => {
    // Only save valid modes
    if (mode === "CFBHome" || mode === "Unlimited") {
      localStorage.setItem("gameMode", mode);
    }
  }, [mode]);

  const updateGamesPlayed = () => {
    const updateGames =
      mode === "CFBHome" ? setHomeTotalGames : setUnlimitedTotalGames;
    updateGames((games) => games + 1);
  };
  const formatFilters = () => {
    const positionFilters = [...selectedPositions].join(", ");
    const teamFilters = [...selectedTeams].map((team) => team).join(", ");
    const statusFilter =
      isActiveOnly === "both"
        ? "Active and Inactive"
        : isActiveOnly === "active"
          ? "Active"
          : "Inactive";
    const draftFilter =
      draftStatus === "both" ? "Drafted and Undrafted" : draftStatus;
    const gamesFilter = `Minimum games: ${minGames}`;
    const awardFilters = [...selectedAwards].join(", "); // Include selected awards in the formatted filters

    return `Positions: ${positionFilters || "All"}, Teams: ${teamFilters || "All"}, Status: ${statusFilter}, Draft: ${draftFilter}, ${gamesFilter}, Awards: ${awardFilters || "All"}`; // Include award filters in the returned string
  };

  const shareAchievement = (playerCount) => {
    const filtersDescription = formatFilters();
    const message = `I've guessed every available player under the current filters in Guess the Player! Total players guessed: ${playerCount}. Filters used: ${filtersDescription}. Can you match me?`;

    // Include social media or clipboard sharing functionality
    // This example uses Twitter sharing
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
    window.open(tweetUrl, "_blank");
    toast.success("Achievement shared on Twitter!");
  };

  const formatCareerAwards = (player) => {
    const awards = [];

    if (player.Pro_Bowl)
      awards.push(`🏈 <strong>Pro Bowl:</strong> ${player.Pro_Bowl}x`);
    if (player.MVP && player.MVP.length)
      awards.push(`🏆 <strong>MVP:</strong> ${player.MVP.join(", ")}`);
    if (player.DPOY && player.DPOY.length)
      awards.push(
        `🛡️ <strong>AP Defensive Player of the Year:</strong> ${player.DPOY.join(", ")}`
      );
    if (player.DROY && player.DROY.length)
      awards.push(
        `🔰 <strong>AP Defensive Rookie of the Year:</strong> ${player.DROY.join(", ")}`
      );
    if (player.OROY && player.OROY.length)
      awards.push(
        `🌟 <strong>AP Offensive Rookie of the Year:</strong> ${player.OROY.join(", ")}`
      );
    if (player.AP1)
      awards.push(`🥇 <strong>All-Pro 1st Team:</strong> ${player.AP1}`);
    if (player.SB_MVP && player.SB_MVP.length)
      awards.push(
        `🏟️ <strong>Super Bowl MVP:</strong> ${player.SB_MVP.join(", ")}`
      );
    if (player.OPOY && player.OPOY.length)
      awards.push(
        `🏅 <strong>AP Offensive Player of the Year:</strong> ${player.OPOY.join(", ")}`
      );
    if (player.CPOY && player.CPOY.length)
      awards.push(
        `💪 <strong>Comeback Player of the Year:</strong> ${player.CPOY.join(", ")}`
      );
    if (player.WPMOTY && player.WPMOTY.length)
      awards.push(
        `💖 <strong>Walter Payton Man of the Year:</strong> ${player.WPMOTY.join(", ")}`
      );

    return awards.map((award) => `<p>${award}</p>`).join("");
  };
  const [filteredPlayers, setFilteredPlayers] = useState([]);

  const getFilteredRandomPlayer = () => {
    const players = playerData.filter((player) => {
      const matchesPosition =
        selectedPositions.size === 0 ||
        player.Pos.some((pos) => selectedPositions.has(pos));
      const matchesTeam =
        selectedTeams.size === 0 ||
        player.Team.some((team) => selectedTeams.has(team));
      const matchesActiveStatus =
        isActiveOnly === "both" ||
        (isActiveOnly === "active"
          ? player.Active === "Yes"
          : player.Active === "No");
      const matchesDraftStatus =
        draftStatus === "both" ||
        (draftStatus === "drafted" ? player.Drafted : !player.Drafted);
      const matchesGameCount = player.G >= minGames;
      const matchesAwards = Array.from(selectedAwards).every(
        (award) => player[award] && player[award] > 0
      );
      const notSeen = !seenPlayerIDs.has(player["Player-additional"]);

      return (
        matchesPosition &&
        matchesTeam &&
        matchesActiveStatus &&
        matchesDraftStatus &&
        matchesGameCount &&
        matchesAwards &&
        notSeen
      );
    });

    setFilteredPlayers(players); // Update the state with the filtered players
    if (players.length === 0) {
      setOutOfPlayers(true);
      return null;
    } else {
      setOutOfPlayers(false);
      return players[Math.floor(Math.random() * players.length)];
    }
  };
  // Define a function to toggle the selection of an award
  const toggleAwardSelection = (award) => {
    const updatedAwards = new Set(tempSelectedAwards);
    if (updatedAwards.has(award)) {
      updatedAwards.delete(award);
    } else {
      updatedAwards.add(award);
    }
    setTempSelectedAwards(updatedAwards);
  };

  useEffect(() => {
    getFilteredRandomPlayer(); // Call this whenever filters change to refresh the list
  }, [
    selectedPositions,
    selectedTeams,
    isActiveOnly,
    draftStatus,
    minGames,
    selectedAwards,
  ]); // Include selectedAwards in the dependency array

  const checkAndHandleCompletion = () => {
    // Only check for completion in Unlimited mode
    if (
      mode === "Unlimited" &&
      seenPlayerIDs.size === filteredPlayers.length &&
      filteredPlayers.length > 0
    ) {
      toast.info(
        "Congratulations! You have guessed every available player under the current filters!",
        {
          onClose: () => shareAchievement(seenPlayerIDs.size),
        }
      );
      setShowNoPlayersModal(true); // Trigger the modal when all players are guessed.
    }
  };

  // Call this in an effect hook that watches changes in the necessary dependencies
  useEffect(() => {
    if (mode === "Unlimited") {
      checkAndHandleCompletion();
    }
  }, [seenPlayerIDs, filteredPlayers, mode]); // Include 'mode' to react to mode changes

  const fetchPlayer = (modeToUse) => {
    if (modeToUse === "CFBHome") {
      // Fetch the scheduled player
      const playerId = playerSchedule[currentDate];
      const scheduledPlayer = playerData.find(
        (p) => p["Player-additional"] === playerId
      );
      if (scheduledPlayer) {
        setCurrentPlayer(scheduledPlayer);
      } else {
        // Use deterministic daily selection
        const dailyIndex = getDailyPlayerIndex(currentDate, playerData.length);
        setCurrentPlayer(playerData[dailyIndex]);
      }
    } else {
      // 'Unlimited' mode, fetch any random player considering filters if applied
      const randomPlayer = getFilteredRandomPlayer(); // Ensure this function considers all active filters
      if (randomPlayer) {
        setCurrentPlayer(randomPlayer);
      } else {
        setCurrentPlayer(
          playerData[Math.floor(Math.random() * playerData.length)]
        );
      }
    }
  };

  const saveSettings = () => {
    // Check if there are changes to save
    const hasChanges =
      !setsAreEqual(new Set(selectedTeams), new Set(tempSelectedTeams)) ||
      !setsAreEqual(
        new Set(selectedPositions),
        new Set(tempSelectedPositions)
      ) ||
      !setsAreEqual(new Set(selectedAwards), new Set(tempSelectedAwards)) || // Check for changes in awards
      isActiveOnly !== tempIsActiveOnly ||
      draftStatus !== tempDraftStatus ||
      minGames !== Number(tempMinGames);

    if (hasChanges) {
      // Update states with new settings
      setSelectedTeams(new Set(tempSelectedTeams));
      setSelectedPositions(new Set(tempSelectedPositions));
      setSelectedAwards(new Set(tempSelectedAwards)); // Update awards state
      setIsActiveOnly(tempIsActiveOnly);
      setDraftStatus(tempDraftStatus);
      setMinGames(Number(tempMinGames));

      // Persist changes to local storage
      localStorage.setItem(
        "selectedTeams",
        JSON.stringify([...tempSelectedTeams])
      );
      localStorage.setItem(
        "selectedPositions",
        JSON.stringify([...tempSelectedPositions])
      );
      localStorage.setItem(
        "selectedAwards",
        JSON.stringify([...tempSelectedAwards])
      ); // Save awards
      localStorage.setItem("isActiveOnly", tempIsActiveOnly);
      localStorage.setItem("draftStatus", tempDraftStatus);
      localStorage.setItem("minGames", Number(tempMinGames).toString());

      // Close settings and refresh data
      setSettingsOpen(false);
      fetchPlayer(mode);
      setSeenPlayerIDs(new Set()); // Clear seen player IDs when switching modes
    } else {
      setSettingsOpen(false);
    }
  };

  function setsAreEqual(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let a of setA) {
      if (!setB.has(a)) return false;
    }
    return true;
  }

  // Helper function to compare sets
  function setsAreEqual(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let a of setA) if (!setB.has(a)) return false;
    return true;
  }

  useEffect(() => {
    fetchPlayer(mode);
  }, [
    mode,
    currentDate,
    selectedTeams,
    selectedPositions,
    isActiveOnly,
    draftStatus,
    minGames,
    selectedAwards,
  ]); // Include all relevant filters as dependencies

  useEffect(() => {
    const loadedTeams = JSON.parse(localStorage.getItem("selectedTeams")) || [];
    setSelectedTeams(new Set(loadedTeams));
  }, []);

  useEffect(() => {
    fetchPlayer(mode);
  }, [mode, currentDate]);

  useEffect(() => {
    if (mode === "Unlimited") {
      fetchPlayer("Unlimited");
    }
  }, [mode, selectedPositions, isActiveOnly, selectedTeams, selectedAwards]); // Include all relevant filters as dependencies

  const togglePositionSelection = (pos) => {
    const newPositions = new Set(tempSelectedPositions);
    if (newPositions.has(pos)) {
      newPositions.delete(pos);
    } else {
      newPositions.add(pos);
    }
    setTempSelectedPositions(newPositions);
  };

  const handleOpenSettings = (open) => {
    const currentStreak =
      mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;
    if (currentStreak > 0) {
      alert("You cannot change filters during an active streak!");
      return;
    }
    setSettingsOpen(open);
    // Initialize temporary states with current settings
    setTempSelectedTeams(new Set(selectedTeams));
    setTempSelectedPositions(new Set(selectedPositions));
    setTempSelectedAwards(new Set(selectedAwards)); // Add this line
    setTempIsActiveOnly(isActiveOnly);
    setTempDraftStatus(draftStatus);
    setTempMinGames(minGames);
  };
  const settingsDialog = (
    <Dialog open={settingsOpen} onClose={() => setSettingsOpen(false)} maxWidth="md" fullWidth>
      <Box sx={{ padding: '32px' }}>
        <Typography variant="h5" component="h2" sx={{ marginBottom: '24px', fontWeight: 700 }}>
          Player Settings
        </Typography>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Positions
          </Typography>
          {[
            "QB",
            "RB",
            "FB",
            "WR",
            "TE",
            "OL",
            "LT",
            "LG",
            "C",
            "RG",
            "RT",
            "DE",
            "LDE",
            "RDE",
            "DT",
            "NT",
            "LB",
            "MLB",
            "LILB",
            "RILB",
            "OLB",
            "CB",
            "LCB",
            "RCB",
            "SS",
            "FS",
            "S",
            "DB",
            "K",
            "P",
            "LS",
          ].map((pos) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSelectedPositions.has(pos)}
                  onChange={() => togglePositionSelection(pos)}
                />
              }
              label={pos}
              key={pos}
            />
          ))}
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Teams
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {teams.map((team, index) => (
              <Button
                key={index}
                onClick={() => toggleTeam(team)}
                variant={selectedTeams.has(team) ? "contained" : "outlined"}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px',
                  minWidth: '80px',
                  ...(selectedTeams.has(team) ? primaryButtonSx : secondaryButtonSx),
                }}
              >
                <img
                  src={teamLogos[team]}
                  alt={team}
                  style={{ width: '32px', height: '32px', objectFit: 'contain' }}
                />
                <Typography variant="caption">{team}</Typography>
              </Button>
            ))}
          </Box>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Player Status
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="player-status"
              name="player-status"
              value={tempIsActiveOnly}
              onChange={(e) => setTempIsActiveOnly(e.target.value)}
            >
              <FormControlLabel
                value="active"
                control={<Radio />}
                label="Active"
              />
              <FormControlLabel
                value="inactive"
                control={<Radio />}
                label="Inactive"
              />
              <FormControlLabel
                value="both"
                control={<Radio />}
                label="Both"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Draft Status
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="draft-status"
              name="draft-status"
              value={tempDraftStatus}
              onChange={(e) => setTempDraftStatus(e.target.value)}
            >
              <FormControlLabel
                value="drafted"
                control={<Radio />}
                label="Drafted"
              />
              <FormControlLabel
                value="undrafted"
                control={<Radio />}
                label="Undrafted"
              />
              <FormControlLabel
                value="both"
                control={<Radio />}
                label="Both"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Minimum Games Played
          </Typography>
          <TextField
            label="Minimum Games Played"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            value={tempMinGames}
            onChange={(e) => setTempMinGames(e.target.value)}
            fullWidth
          />
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h6" sx={{ marginBottom: '16px', fontWeight: 600 }}>
            Awards
          </Typography>
          {awards.map((award, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={tempSelectedAwards.has(award)}
                  onChange={() => toggleAwardSelection(award)}
                />
              }
              label={award}
              key={index}
            />
          ))}
        </Box>

        <Button
          onClick={saveSettings}
          variant="contained"
          sx={primaryButtonSx}
          fullWidth
        >
          Save Settings
        </Button>
      </Box>
    </Dialog>
  );

  const revealHint = () => {
    const newHints = [...hintsGiven];

    if (newHints.length === 0 && currentPlayer) {
      newHints.push(currentPlayer.Pos); // First hint: Position
    } else if (newHints.length === 1 && currentPlayer) {
      // Determine the draft detail or undrafted status based on the presence of a draft year
      const draftDetail =
        currentPlayer.Round && currentPlayer.Pick
          ? `Round: ${currentPlayer.Round}, Pick: ${currentPlayer.Pick}, Year: ${currentPlayer.DrftYr}`
          : `Undrafted, Started Playing: ${currentPlayer.From}`;

      newHints.push(draftDetail);
    }
    setHintsGiven(newHints);
  };

  const postStreakToLeaderboard = async (playerID, streak) => {
    try {
      const response = await fetch(
        "https://us-central1-crossover-grid-511a4.cloudfunctions.net/api/updateLeaderboard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ playerID, score: streak }),
        }
      );
      const responseData = await response.json();
      if (response.ok) {
        toast.success("Streak updated on leaderboard!");
      } else {
        throw new Error(responseData.message || "Failed to update streak");
      }
    } catch (error) {
      toast.error("Error updating leaderboard: " + error.message);
    }
  };

  const getRandomPlayer = () => {
    return playerData[Math.floor(Math.random() * playerData.length)];
  };

  // Fetch player only when mode or currentDate changes.
  useEffect(() => {
    fetchPlayer(mode);
  }, [mode, currentDate]);
  // Handle changes in settings for "Unlimited" mode separately
  useEffect(() => {
    if (mode === "Unlimited") {
      fetchPlayer("Unlimited");
    }
  }, [mode, selectedPositions, isActiveOnly, selectedTeams, selectedAwards]);

  // Fetch the player data on component mount
  const handleGuessChange = (event) => {
    const value = event.target.value;
    setUserGuess(value);

    const trimmedValue = value.trim().toLowerCase(); // Prepare the input for comparison

    if (trimmedValue.length > 0) {
      // Create a map to accumulate players by name
      const playersByName = new Map();
      playerData.forEach((player) => {
        const playerName = player.Player.toLowerCase();
        if (playerName.includes(trimmedValue)) {
          if (!playersByName.has(player.Player)) {
            playersByName.set(player.Player, []);
          }
          playersByName.get(player.Player).push(player);
        }
      });

      const filteredSuggestions = Array.from(playersByName).map(
        ([name, players]) => ({
          Player: name,
          ids: players.map((p) => p.PlayerId), // Store all relevant IDs
          details: players, // You could store additional details here if needed
        })
      );

      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const selectPlayer = (selectedName) => {
    const playerInfo = suggestions.find((s) => s.Player === selectedName);
    if (playerInfo.ids.length === 1) {
      setCurrentPlayerId(playerInfo.ids[0]); // Setting the ID from the single ID found
    } else {
      // You might need logic here to handle multiple IDs
      // For now, let's just set the first one
      setCurrentPlayerId(playerInfo.ids[0]);
    }
    setUserGuess(selectedName);
    setSuggestions([]);
  };

  const handleSelectPlayer = (player) => {
    setUserGuess(player.Player);
    setSuggestions([]);
    // If needed, perform additional actions when a player is selected
  };
  const handleGuessSubmit = (event) => {
    event.preventDefault();
    toast.dismiss();

    // Debug logging
    console.log("=== GUESS SUBMIT DEBUG ===");
    console.log("Mode:", mode);
    console.log("Played Today:", playedToday);
    console.log("Current Date:", currentDate);
    console.log("Current Player:", currentPlayer);
    console.log("User Guess:", userGuess);
    console.log("localStorage for date:", localStorage.getItem(currentDate));

    // Validate input
    if (!userGuess || userGuess.trim() === "") {
      toast.error("Please enter a player name!");
      return;
    }

    // Validate player data
    if (!currentPlayer || !currentPlayer.Player) {
      toast.error("Error loading player data. Please refresh the page.");
      return;
    }

    if (mode === "Unlimited" || (mode === "CFBHome" && !playedToday)) {
      const isCorrectGuess =
        userGuess.trim().toLowerCase() === currentPlayer.Player.toLowerCase();
      if (isCorrectGuess) {
        // Correct Guess
        setSeenPlayerIDs(
          (prev) => new Set(prev.add(currentPlayer["Player-additional"]))
        ); // Update seenPlayerIDs when a correct guess is made
        toast.success(
          `${currentPlayer.Player} was correct! Guessed in ${3 - guessesLeft + 1} tries!`
        );
        endGame(true);
      } else {
        // Incorrect Guess
        if (guessesLeft > 1) {
          setGuessesLeft(guessesLeft - 1);
          toast.error(`Incorrect guess: ${userGuess}. Try again!`);
          revealHint();
        } else {
          // No guesses left, end the game
          endGame(false);
        }
      }
      setUserGuess("");
    } else {
      toast.error("Cannot submit guess in current game state.");
      console.error("Invalid game state:", { mode, playedToday });
    }
  };
  const endGame = (gameWon) => {
    updateGamesPlayed();
    setGuessesLeft(3);
    setHintsGiven([]);
    setUserGuess("");

    if (gameWon) {
      updateWinsAndStreak();
      // Potential logic to handle a win situation
    } else {
      // Game ends because of an incorrect guess
      const currentStreak =
        mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;
      if (currentStreak >= 5) {
        // Only show the streak modal if the game ends due to a wrong guess and the streak was 5 or more
        setShowStreakModal(true);
        // Defer streak reset until modal is dismissed
      } else {
        // Reset streak immediately if it was less than 5
        resetStreak();
      }
      toast.error(
        `No more guesses left! The correct player was ${currentPlayer.Player}.`
      );
    }

    setPlayedToday(mode === "CFBHome");
    if (mode === "Unlimited" || !gameWon) {
      fetchPlayer(mode); // Fetch a new player for Unlimited or after a loss.
    }

    if (mode === "CFBHome") {
      setPlayedToday(true);
      localStorage.setItem(currentDate, "played");
    }
  };

  const NoPlayersAvailableModal = ({ open, onClose, onShare, onRestart }) => {
    return (
      <Dialog open={open} onClose={onClose}>
        <div style={{ padding: 20, textAlign: "center" }}>
          <h2>No More Players Available</h2>
          <p>There are no more players available under the current filters.</p>
          <div>
            <Button
              onClick={onClose}
              color="primary"
              style={{ margin: "10px" }}
            >
              Close
            </Button>
            <Button
              onClick={onShare}
              color="secondary"
              style={{ margin: "10px" }}
            >
              Share Achievement
            </Button>
            <Button
              onClick={onRestart}
              color="secondary"
              style={{ margin: "10px" }}
            >
              Restart Game
            </Button>
          </div>
        </div>
      </Dialog>
    );
  };
  const StreakModal = ({ open, onClose }) => {
    const currentStreak =
      mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onBackdropClick={onClose}
        onEscapeKeyDown={onClose}
      >
        <div style={{ padding: 20, textAlign: "center" }}>
          <h2>Congratulations!</h2>
          <p>You have achieved a streak of {currentStreak} correct guesses!</p>
          <p>Your streak has been added to the leaderboard.</p>
          <div>
            <Button
              onClick={() => {
                shareScore(); // Optional: trigger score sharing
                onClose(); // This ensures all close actions lead through the close handler
              }}
              color="primary"
              style={{ margin: "10px" }}
            >
              Share on Twitter
            </Button>
            <Button
              onClick={onClose}
              color="secondary"
              style={{ margin: "10px" }}
            >
              Close
            </Button>
          </div>
        </div>
      </Dialog>
    );
  };

  const handleResetGame = () => {
    setSeenPlayerIDs(new Set());
    setFiltersToDefault(); // Reset all filters to default state or as you define
    fetchPlayer("Unlimited"); // Fetch players again after resetting
    setShowNoPlayersModal(false); // Close the modal
  };

  const handleShareAchievement = () => {
    // Assume that player count is being tracked somewhere in state
    shareAchievement(seenPlayerIDs.size);
    setShowNoPlayersModal(false); // Optionally close the modal after sharing
  };
  const handleStreakModalClose = () => {
    resetStreak(); // This will reset the streak to 0
    setShowStreakModal(false); // Close the modal
  };

  const setFiltersToDefault = () => {
    setSelectedPositions(new Set()); // Assuming no positions are selected by default
    setSelectedTeams(new Set()); // Assuming no teams are selected by default
    setIsActiveOnly("both"); // Assuming the default is to show both active and inactive players
    setDraftStatus("both"); // Assuming the default is to show both drafted and undrafted players
    setMinGames(0); // Assuming the default is no minimum games played
    setSelectedAwards(new Set()); // Reset selected awards to an empty set

    // Reset any additional filter states here as needed
  };

  useEffect(() => {
    // Show modal only in Unlimited mode and when there are no more players to guess
    if (mode === "Unlimited" && outOfPlayers && filteredPlayers.length === 0) {
      setShowNoPlayersModal(true);
    } else {
      setShowNoPlayersModal(false);
    }
  }, [mode, outOfPlayers, filteredPlayers.length]);

  useEffect(() => {
    localStorage.setItem("homeTotalGames", homeTotalGames);
    localStorage.setItem("homeTotalWins", homeTotalWins);
    localStorage.setItem("homeWinStreak", homeWinStreak);

    localStorage.setItem("unlimitedTotalGames", unlimitedTotalGames);
    localStorage.setItem("unlimitedTotalWins", unlimitedTotalWins);
    localStorage.setItem("unlimitedWinStreak", unlimitedWinStreak);
  }, [
    homeTotalGames,
    homeTotalWins,
    homeWinStreak,
    unlimitedTotalGames,
    unlimitedTotalWins,
    unlimitedWinStreak,
  ]);

  const shareScore = () => {
    const currentStreak =
      mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;
    const filtersDescription = formatFilters();

    const tweetText = `I guessed ${currentStreak} players under the current filters in Guess the Player!  Filters used: ${filtersDescription}.`;
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
    window.open(url, "_blank");
  };
  {
    showHowToPlay && (
      <HowToPlayModal open={showHowToPlay} onClose={toggleHowToPlayModal} />
    );
  }

  useEffect(() => {
    setPlayedToday(localStorage.getItem(currentDate) === "played");
  }, [currentDate]);

  const location = useLocation();
  
  if (!currentPlayer) {
    return (
      <>
        <PageInfo
          title="Guess The Player - NFL Player Guessing Game"
          metaTitle="Guess The Player - NFL Player Guessing Game"
          metaDescription="Guess the NFL player based on their career path, teams, awards, and stats. Test your football knowledge with daily and unlimited challenges!"
          metaUrl={location.pathname}
          keywords={["guess the player", "nfl player guesser", "football trivia", "player guessing game", "nfl trivia"]}
          twitterCreator="@CrossoverGridFB"
        />
        <div>Loading player data...</div>
      </>
    );
  }
  // Early return if today's challenge has been completed
  if (mode === "CFBHome" && playedToday) {
    const currentStreak =
      mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak;
    const guessesUsed = 3 - guessesLeft + 1;
    return (
      <>
        <PageInfo
          title="Guess The Player - NFL Player Guessing Game"
          metaTitle="Guess The Player - NFL Player Guessing Game"
          metaDescription="Guess the NFL player based on their career path, teams, awards, and stats. Test your football knowledge with daily and unlimited challenges!"
          metaUrl={location.pathname}
          keywords={["guess the player", "nfl player guesser", "football trivia", "player guessing game", "nfl trivia"]}
          twitterCreator="@CrossoverGridFB"
        />
        <Box sx={containerSx}>
        <Card sx={cardSx}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700, textAlign: 'center', marginBottom: '20px' }}>
            Guess the Player
            {mode === "Unlimited" && (
              <IconButton
                onClick={() => handleOpenSettings(true)}
                style={{ marginLeft: "10px", verticalAlign: "middle" }}
                title="Filter settings"
              >
                <FilterListIcon />
              </IconButton>
            )}
          </Typography>

          <Typography variant="body1" sx={{ marginBottom: '16px', textAlign: 'center' }}>
            You've already played today's challenge. Here's the result:
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: '20px', textAlign: 'center', fontWeight: 600 }}>
            The correct player was: {currentPlayer.Player}
          </Typography>

          <Button onClick={handleModeChange} sx={primaryButtonSx}>
            Switch to Unlimited
          </Button>

          {/* Share button for CFBHome mode */}
          <Button
            onClick={() => {
              const tweetText = `I guessed the @CFBHome correct player in ${guessesUsed} guess${guessesUsed > 1 ? "es" : ""}! My win streak is ${currentStreak}! `;
              const tweetUrl = "1782399386833616947"; // Only include the tweet ID
              const encodedTweetText = encodeURIComponent(tweetText);
              const encodedTweetUrl = encodeURIComponent(tweetUrl);
              const url = `https://twitter.com/intent/tweet?text=${encodedTweetText}&in_reply_to=${encodedTweetUrl}`;
              window.open(url, "_blank");
            }}
            sx={secondaryButtonSx}
          >
            Share result on Twitter
          </Button>

          {/* Copy button for CFBHome mode */}
          <Button
            onClick={() => {
              navigator.clipboard.writeText(
                `I guessed the correct player in ${guessesUsed} guess${guessesUsed > 1 ? "es" : ""}! My win streak is ${currentStreak}! Can you beat me?`
              );
            }}
            sx={secondaryButtonSx}
          >
            Copy result to Clipboard
          </Button>
        </Card>
      </Box>
      </>
    );
  }
  const teamHeaderText =
    currentPlayer.Team.length > 1 ? "Teams Played For" : "Team Played For"; // This could be singular if only one team

  return (
    <div className="app">
      <PageInfo
        title="Guess The Player - NFL Player Guessing Game"
        metaTitle="Guess The Player - NFL Player Guessing Game"
        metaDescription="Guess the NFL player based on their career path, teams, awards, and stats. Test your football knowledge with daily and unlimited challenges!"
        metaUrl={location.pathname}
        keywords={["guess the player", "nfl player guesser", "football trivia", "player guessing game", "nfl trivia"]}
        twitterCreator="@CrossoverGridFB"
      />
      <ToastContainer position="top-center" limit={2} />

      <Container>
        <nav className="navbar">
          {/* Navbar content */}
          <a
            href="https://crossovergrid.com"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center", // This ensures vertical alignment
              justifyContent: "center", // This centers the content horizontally if the a-tag is a flex container
            }}
          >
            <img src={crossover_logo} alt="Logo" className="navbar-logo" />
            <p
              style={{
                margin: 0, // Removes default margin that might offset alignment
                fontWeight: "bold",
                fontSize: 20,
                display: "flex", // Makes the paragraph itself a flex container
                alignItems: "center", // Centers the text inside the p-tag vertically
                justifyContent: "center", // Centers the text inside the p-tag horizontally
              }}
            >
              CROSSOVER GRID NFL
            </p>
          </a>
          <div>
            <IconButton href="/" title="Home">
              <HomeIcon />
            </IconButton>
            <IconButton
              onClick={() => handleOpenSettings(true)}
              style={{ color: "inherit" }}
            >
              <SettingsIcon />
            </IconButton>
          </div>
        </nav>
      </Container>
      {settingsDialog}

      <div className="sport-picker">
        {/* Sport picker content */}
        <div className="links">
          {sports.map((sport) => (
            <Link
              key={sport.id}
              className={`sportLink ${sport.id === "21" ? "prime-gaming-logo" : ""} ${page_name === sport.id ? "selected" : ""}`}
              to={sport.path}
            >
              {sport.emoji.startsWith("http") ? (
                <img src={sport.emoji} alt={sport.name} />
              ) : (
                <span>{sport.emoji}</span>
              )}
              <br />
              {sport.name.length < 4 ? (
                <span>{sport.name}</span>
              ) : (
                <span style={{ fontSize: 12 }}>{sport.name}</span>
              )}
            </Link>
          ))}
        </div>
      </div>
      <Button onClick={handleModeChange} sx={primaryButtonSx}>
        {mode === "CFBHome" ? "Switch to Unlimited" : "Switch to CFBHome"}
      </Button>

      <Box sx={containerSx}>
        <Card sx={cardSx}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700, textAlign: 'center', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Guess the Player
            <IconButton
              onClick={toggleHowToPlayModal}
              title="How to Play"
              style={{ marginLeft: "10px" }}
            >
              <HelpOutlineIcon />
            </IconButton>
            {showHowToPlay && (
              <HowToPlayModal
                open={showHowToPlay}
                onClose={toggleHowToPlayModal}
              />
            )}
          </Typography>
          {showEditPlayerIDModal && (
            <EditPlayerIDModal
              open={showEditPlayerIDModal}
              onClose={toggleEditPlayerIDModal}
            />
          )}
          {showNoPlayersModal && (
            <NoPlayersAvailableModal
              open={showNoPlayersModal}
              onClose={() => setShowNoPlayersModal(false)}
              onShare={handleShareAchievement}
              onRestart={handleResetGame}
            />
          )}
          {showStreakModal && (
            <StreakModal
              open={showStreakModal}
              onClose={handleStreakModalClose} // Ensure this handles all close actions
            />
          )}
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
            {mode === "Unlimited" && (
              <>
                <IconButton
                  onClick={() => handleOpenSettings(true)}
                  title="Filter settings"
                  sx={{ color: 'primary.main' }}
                >
                  <SettingsIcon />
                </IconButton>
                <IconButton
                  onClick={toggleEditPlayerIDModal}
                  title="Edit Player ID"
                  sx={{ color: 'primary.main' }}
                >
                  <EditIcon />
                </IconButton>
                <Typography variant="body2" sx={{ padding: '8px 16px', backgroundColor: 'rgba(70, 102, 175, 0.1)', borderRadius: '8px', fontWeight: 600 }}>
                  Available Players: {filteredPlayers.length}
                </Typography>
                <Button
                  onClick={openLeaderboardModal}
                  variant="contained"
                  sx={primaryButtonSx}
                >
                  Show Leaderboard
                </Button>
              </>
            )}
          </Box>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            flexWrap: 'wrap',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(70, 102, 175, 0.05)',
            borderRadius: '12px',
            marginTop: '24px',
            marginBottom: '24px'
          }}>
            <Typography variant="body2" sx={{ margin: 0 }}>
              🏆 Win %:{" "}
              {mode === "CFBHome"
                ? homeTotalGames
                  ? ((homeTotalWins / homeTotalGames) * 100).toFixed(2)
                  : 0
                : unlimitedTotalGames
                  ? ((unlimitedTotalWins / unlimitedTotalGames) * 100).toFixed(
                      2
                    )
                  : 0}
              %
            </Typography>
            <Typography variant="body2" sx={{ margin: 0 }}>
              🎮 Total: {mode === "CFBHome" ? homeTotalGames : unlimitedTotalGames}
            </Typography>
            <Typography variant="body2" sx={{ margin: 0 }}>
              🔥 Streak: {mode === "CFBHome" ? homeWinStreak : unlimitedWinStreak}
            </Typography>
            <Typography variant="body2" sx={{ margin: 0 }}>
              ⭐ Best: {mode === "CFBHome" ? homeHighestStreak : unlimitedHighestStreak}
            </Typography>
            {mode === "Unlimited" && guessesLeft === 0 && (
              <Button onClick={shareScore} sx={secondaryButtonSx}>
                Share on Twitter
              </Button>
            )}
          </Box>
          <div>
            <LeaderboardModal
              open={showLeaderboardModal}
              onClose={closeLeaderboardModal}
              leaderboard={leaderboard}
              fetchLeaderboard={fetchLeaderboard}
            />
          </div>
          {/* Form for player guesses */}
          <Box component="form" onSubmit={handleGuessSubmit} sx={{ marginTop: '24px', marginBottom: '24px' }}>
            <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <TextField
                type="text"
                value={userGuess}
                onChange={handleGuessChange}
                placeholder="Enter player's name"
                variant="outlined"
                fullWidth
                sx={{ marginRight: '10px' }}
              />
              <Button type="submit" variant="contained" sx={primaryButtonSx}>
                Guess
              </Button>
            </Box>
            {suggestions.length > 0 && (
              <Paper sx={{ marginTop: '8px', maxHeight: '300px', overflow: 'auto' }}>
                <List>
                  {suggestions.map((suggestion, index) => (
                    <ListItem
                      key={index}
                      onClick={() => selectPlayer(suggestion.Player)}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: 'rgba(70, 102, 175, 0.1)',
                        },
                        borderBottom: index < suggestions.length - 1 ? '1px solid' : 'none',
                        borderColor: 'divider',
                      }}
                    >
                      <ListItemText primary={suggestion.Player} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </Box>
          <Typography variant="h6" sx={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px', color: 'primary.main', fontWeight: 600 }}>
            Guesses Left: {guessesLeft}
          </Typography>
          {hintsGiven.map((hint, index) => {
            return (
              <Paper key={index} sx={{ ...infoBlockSx, backgroundColor: 'warning.light', borderColor: 'warning.main' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '8px' }}>
                  {index === 0 ? "Position" : "Draft Details"}
                </Typography>
                <Typography variant="body1">{hint}</Typography>
              </Paper>
            );
          })}
          <Paper sx={infoBlockSx}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '12px' }}>
              College Drafted From
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {currentPlayer.College ? (
                <>
                  <img
                    src={`https://crossover-grid.s3.amazonaws.com/college-logos/${currentPlayer.College.toLowerCase().replace(/[()&]/g, "").replace(/ /g, "-")}.png`}
                    alt={currentPlayer.College}
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                  />
                  <Typography variant="body1">{currentPlayer.College}</Typography>
                </>
              ) : (
                <Typography variant="body1">Undrafted</Typography>
              )}
            </Box>
          </Paper>
          {hasDraftDetails && currentPlayer && (
            <Paper sx={infoBlockSx}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '12px' }}>
                Team Drafted By
              </Typography>
              <img
                src={
                  teamLogos[currentPlayer?.Drafted || currentPlayer.Team?.[0]]
                }
                alt={currentPlayer?.Drafted || currentPlayer.Team?.[0]}
                style={{ width: '60px', height: '60px', objectFit: 'contain' }}
              />
            </Paper>
          )}
          {/* Teams played for block */}
          <Paper sx={infoBlockSx}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '12px' }}>
              {teamHeaderText}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {currentPlayer.Team.map((team) => (
                <img
                  src={teamLogos[team]}
                  key={team}
                  alt={team}
                  style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                />
              ))}
            </Box>
          </Paper>
          <Paper sx={infoBlockSx}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '12px' }}>
              Career Info
            </Typography>
            <Box>
              <Typography variant="body2" sx={{ marginBottom: '8px' }}>
                Games: {currentPlayer.G || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ marginBottom: '12px' }}>
                Games Started: {currentPlayer.GS || "N/A"}
              </Typography>
              {/* Additional Awards and Honors */}
              <div
                dangerouslySetInnerHTML={createMarkup(
                  formatCareerAwards(currentPlayer)
                )}
              />
            </Box>
          </Paper>
          <Paper sx={{ ...infoBlockSx, marginTop: '24px' }}>
            <Typography variant="body2">
              <strong>Player ID:</strong> {playerIDInput || "No Player ID set"}
            </Typography>
          </Paper>
          <Typography variant="body2" sx={{ textAlign: 'center', marginTop: '16px', color: 'text.secondary' }}>
            Available players: {filteredPlayers.length}
          </Typography>
        </Card>
      </Box>
    </div>
  );
};

export default GuessThePlayer;
